/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   CurrentSearchView actions
 */

import { createAction } from 'redux-actions'
import { BEGIN_SHIMMER, FINISH_SHIMMER, HIDE_MARKERS, SHOW_MARKERS } from '../constants'

export const beginShimmer = createAction(BEGIN_SHIMMER)
export const finishShimmer = createAction(FINISH_SHIMMER)

export const showMarkers = createAction(SHOW_MARKERS)
export const hideMarkers = createAction(HIDE_MARKERS)
